import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  configurationSettingDetail,
  configurationSettingUpdate,
} from "reduxStore/action/configurationSettingAction";
import strings from "translate/language";
import { errorToast } from "utils/httpClient";
import { seo } from "utils/utils";
import Breadcrumb from "component/common/breadcrumb";
import Button from "../../component/Button";

const NotificationMapKey = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [formVaild, setFormVaild] = useState({});
  const [form, setForm] = useState({});
  const [isModify, setIsModify] = useState(true);
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const configurationSettingDetailSelector =
    useSelector((state) => state?.configurationSettingDetail) || [];
  useEffect(() => {
    dispatch(configurationSettingDetail({ type: "map_notification" }));
  }, []);

  useEffect(() => {
    if (configurationSettingDetailSelector.detail === true) {
      if (configurationSettingDetailSelector?.response?.status === 200) {
        setForm({
          ...form,
          _id: configurationSettingDetailSelector.response.data._id,
          map_key: configurationSettingDetailSelector.response.data.map_key,
          fcm_key: configurationSettingDetailSelector.response.data.fcm_key,
        });
      } else {
        errorToast(configurationSettingDetailSelector?.response?.message);
      }
    }
  }, [configurationSettingDetailSelector]);

  const handleUpdate = () => {
    if (!handleValid()) {
      const post = {
        setting_id: form._id,
        map_key: form.map_key,
        fcm_key: form.fcm_key,
      };
      setIsModify(true);
      dispatch(configurationSettingUpdate(post));
    }
  };
  const handleValid = () => {
    let err = {};
    let formError = false;
    if (!form.map_key) {
      formError = true;
      err["map_key"] = strings.mapKey_Err;
    }
    if (!form.fcm_key) {
      formError = true;
      err["fcm_key"] = strings.fcmKey_err;
    }
    setFormVaild(err);
    return formError;
  };
  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
  };
  useEffect(() => {
    seo({
      title: "Notification Map Key",
      metaDescription: "Notification map key",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.configurationSetting}
        titleactive={strings.notificationMapKey}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header pb-0">
                <h5>{strings.notificationMapKey}</h5>
              </div>
              <div className="card-body">
                <form>
                  <fieldset disabled={isModify}>
                    <div className="row ">
                      <div className="col-md-8 ">
                        <div className="form-group">
                          <label htmlFor="exampleFormControlFirstName">
                            {strings.mapKey}
                          </label>
                          <input
                            className="form-control"
                            id="exampleFormControlFirstName"
                            type="text"
                            name="map_key"
                            autoComplete="off"
                            value={form.map_key}
                            onChange={handleInputField}
                          />
                          {formVaild.map_key && (
                            <span style={{ color: "red" }}>
                              {formVaild.map_key}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-md-8 ">
                        <div className="form-group">
                          <label htmlFor="exampleFormControlFirstName">
                            {strings.fcmKey}
                          </label>
                          <input
                            className="form-control"
                            id="exampleFormControlFirstName"
                            type="text"
                            name="fcm_key"
                            autoComplete="off"
                            value={form.fcm_key}
                            onChange={handleInputField}
                          />
                          {formVaild.fcm_key && (
                            <span style={{ color: "red" }}>
                              {formVaild.fcm_key}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </fieldset>
                  <div className="row">
                    <div className="col-md-12 d-flex justify-content-end">
                      <div className="card-footer">
                        <Button
                          className="btn btn-color mr-5"
                          onClick={() => setIsModify(!isModify)}
                          label={strings.modify}
                        ></Button>
                        <Button
                          className="btn btn-color"
                          disabled={isModify}
                          onClick={() => handleUpdate()}
                          label={strings.update}
                        ></Button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default NotificationMapKey;
